import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

interface SmartBackLinkProps {
  className?: string;
}

/**
 * Back link that:
 * - Logged-in users with history: navigate(-1) labeled "Back"
 * - Anonymous users (or no history): Link to "/" labeled "Back to Home"
 */
export default function SmartBackLink({ className }: SmartBackLinkProps) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const baseClass =
    className ??
    'inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors';

  const canGoBack = typeof window !== 'undefined' && window.history.length > 1;

  if (user && canGoBack) {
    return (
      <button type="button" onClick={() => navigate(-1)} className={baseClass}>
        <ArrowLeft className="h-4 w-4" />
        Back
      </button>
    );
  }

  return (
    <Link to="/" className={baseClass}>
      <ArrowLeft className="h-4 w-4" />
      Back to Home
    </Link>
  );
}
